import React from 'react';

import UserPresenter from '../../../../../../../../presenters/UserPresenter';
import appRoutes from '../../../../../../../../routes/appRoutes';

const InvitedUser = (props) => {
  const { user } = props;
  const auth0Id = UserPresenter.auth0Id(user);

  return (
    <div key={UserPresenter.auth0Id(user)}>
      <a
        href={appRoutes.userFastCashPath({ byAuth0Id: auth0Id })}
        target="_blank"
      >
        {UserPresenter.fullName(user)}
      </a>
    </div>
  );
};

export default InvitedUser;

InvitedUser.propTypes = {
  user: UserPresenter.shape().isRequired,
};
